document.addEventListener('DOMContentLoaded', function () {
  const section = document.getElementById('points-section-sticky');
  if (!section) return;

  const wrapper = section.parentElement;
  const items = Array.from(section.querySelectorAll('.port-section__item'));
  const dots = Array.from(section.querySelectorAll('.port-section__dot'));
  const tabs = section.querySelectorAll('.port-section__tabs li');
  const images = section.querySelectorAll('.port-section__img');
  let currentIndex = 0;
  let initialized = false;

  // Wrap .port-section__item + .port-section__dot in a wrapper below 992px
  function wrapItemsAndDots() {
    if (window.innerWidth < 992) {
      // Remove existing wrappers if any
      section.querySelectorAll('.port-pair-wrapper').forEach(w => {
        while (w.firstChild) {
          section.insertBefore(w.firstChild, w);
        }
        w.remove();
      });

      items.forEach((item, i) => {
        const dot = dots[i];
        if (!dot) return;

        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('port-pair-wrapper');
        wrapperDiv.setAttribute('data-index', item.dataset.index); // add data-index
        item.before(wrapperDiv);
        wrapperDiv.appendChild(item);
        wrapperDiv.appendChild(dot);
      });
    } else {
      // Unwrap above 992px
      section.querySelectorAll('.port-pair-wrapper').forEach(w => {
        while (w.firstChild) {
          section.insertBefore(w.firstChild, w);
        }
        w.remove();
      });
    }
  }

  wrapItemsAndDots(); // initial wrap
  window.addEventListener('resize', wrapItemsAndDots);

  // Activate item / tab / dot
  function activate(index, scrollIntoView = true) {
    currentIndex = index;
    const currentItem = items[index];
    const tabIndex = parseInt(currentItem.dataset.tab);

    // items.forEach((item, i) => item.classList.toggle('active', i === index));
    items.forEach((item, i) => {
      const itemTab = parseInt(item.dataset.tab);

      // Hide items from other tabs
      if (itemTab !== tabIndex) {
        item.style.display = 'none';
        item.classList.remove('active');
      } else {
        item.style.display = 'block';
        item.classList.toggle('active', i === index);
      }
    });
    tabs.forEach(tab => tab.classList.toggle('active', parseInt(tab.dataset.tab) === tabIndex));
    images.forEach(img => img.classList.toggle('active', parseInt(img.dataset.tab) === tabIndex));
    dots.forEach(dot => {
      const dotTab = parseInt(dot.dataset.tab);
      const dotIndex = parseInt(dot.dataset.index);
      dot.style.display = dotTab === tabIndex ? 'block' : 'none';
      dot.classList.toggle('active', dotTab === tabIndex && dotIndex === parseInt(currentItem.dataset.index));
    });

    // slider
    if ($(items).hasClass('slick-initialized')) {
      const tabItems = Array.from(items).filter(i => parseInt(i.dataset.tab) === tabIndex);
      const slideIndex = tabItems.indexOf(currentItem);
      $(items).slick('slickGoTo', slideIndex, true);
    } else if (scrollIntoView && initialized) {
      // scroll
      const rect = currentItem.getBoundingClientRect();
      const isVisible = rect.top >= 0 && rect.bottom <= 0;
      if (!isVisible) currentItem.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  items.forEach(item => item.addEventListener('click', () => activate(parseInt(item.dataset.index))));
  dots.forEach(dot => dot.addEventListener('click', () => activate(parseInt(dot.dataset.index))));
  tabs.forEach(tab => tab.addEventListener('click', () => {
    const tabIndex = parseInt(tab.dataset.tab);

    // Currently active item in this tab
    let targetItem = Array.from(items).find(i =>
      parseInt(i.dataset.tab) === tabIndex &&
      i.classList.contains('active')
    );

    // Fallback to first item
    if (!targetItem) {
      targetItem = Array.from(items).find(i =>
        parseInt(i.dataset.tab) === tabIndex
      );
    }

    if (targetItem) activate(parseInt(targetItem.dataset.index));
  }));

  // Update wrapper height
  function updateWrapperHeight() {
    if (window.matchMedia("(min-width: 992px)").matches) {
      const totalItems = items.length;
      wrapper.style.height = section.offsetHeight * totalItems + 'px';
    } else {
      wrapper.style.height = 'auto';
    }
  }

  updateWrapperHeight();
  window.addEventListener('resize', updateWrapperHeight);

  // scroll
  if (window.matchMedia("(min-width: 992px)").matches) {
    window.addEventListener('scroll', () => {
      const start = wrapper.offsetTop;
      const end = start + wrapper.offsetHeight - window.innerHeight;
      if (window.scrollY < start || window.scrollY > end) return;
      const progress = (window.scrollY - start) / (end - start);
      const index = Math.min(items.length - 1, Math.floor(progress * items.length));
      if (index !== currentIndex) activate(index);
    });
  }

  // slider
  if ($(items).length && typeof $.fn.slick !== 'undefined') {
    const textContainer = section.querySelector('.port-section__text');
    const containerStyles = window.getComputedStyle(textContainer);
    const containerHeight = textContainer.clientHeight - parseFloat(containerStyles.paddingTop) - parseFloat(containerStyles.paddingBottom);
    const itemHeight = items[0].offsetHeight; 
    const visibleCount = Math.min(4, Math.floor(containerHeight / itemHeight));
    $(textContainer).slick({
      vertical: true,
      slidesToShow: visibleCount,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 991,
          settings: "unslick"
        }
      ]
    });
  }

  initialized = true;
  activate(0, false);
});